<template>
  <j-modal
    :width="650"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top: 5%; max-height: 95%"
    @cancel="handleCancel"
    :footer="null"
  >
    <div class="title-item">添加标签</div>
    <div>
      <a-checkable-tag
        class="tag-item"
        v-for="(item, index) in labelList"
        :key="index"
        v-model="item.checked"
        @change="() => changeTag(item)"
      >
        {{ item.name }}
      </a-checkable-tag>
      <div class="title-item">关爱级别</div>
      <a-select
        v-model="type"
        placeholder="请选择关爱名单"
        style="width: 100%; margin-right: 15px; margin-bottom: 20px"
        :options="careListOptions"
        allowClear
        @change="changeSelect"
      />
    </div>
  </j-modal>
</template>

<script>
import { deleteAction, getAction, postAction, putAction } from '@api/manage'

export default {
  name: 'AddLabelModal',
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      labelList: [],
      type: '',
      careListOptions: [
        {
          label: '正常',
          value: 0,
        },
        {
          label: '一级学生',
          value: 1,
        },
        {
          label: '二级学生',
          value: 2,
        },
        {
          label: '三级学生',
          value: 3,
        },
      ],
      studentInfo: {},
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    show(data) {
      this.visible = true
      console.log('消息推送--', data)
      this.getTagList(data)
      this.studentInfo = data
    },
    async getTagList(data) {
      const paramsData = { beginDate: data.beginDate, endDate: data.endDate, dataType: 3 }
      const res = await getAction('/studentTag/getByStudentId', {
        studentId: data.studentId,
      })
      const { result } = await getAction('/statistic/getKeyword', paramsData)
      this.labelList = result
      this.type = res.result.care_list
      if (res.result.tagIdList.length) {
        res.result.tagIdList.forEach((item) => {
          const index = this.labelList.findIndex((i) => i.period_id === item)
          if (index !== -1) {
            this.$set(this.labelList[index], 'checked', true)
          }
        })
      }
    },
    // 选中的标签
    selectTag(data) {
      postAction('/studentTag/add', data).then((res) => {
        if (res.success) {
          this.$message.success(res.result || '添加标签成功')
          return
        }
        this.$message.error(res.result || '添加标签失败')
      })
    },
    // 取消选中标签
    cancelTagSelect(data) {
      deleteAction('/studentTag/delete', data).then((res) => {
        if (res.success) {
          this.$message.success(res.result || '取消标签成功')
          return
        }
        this.$message.error(res.result || '取消标签失败')
      })
    },
    changeTag(data) {
      console.log('标签状态：', data)
      let paramsData = { studentId: this.studentInfo.studentId, tagId: data.period_id }
      if (data.checked) {
        this.selectTag(paramsData)
      } else {
        this.cancelTagSelect(paramsData)
      }
    },
    changeSelect(value) {
      putAction('/aigoes/studentInfo/edit', {
        id: this.studentInfo.studentId,
        careList: value,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.result || '修改关爱级别成功')
          return
        }
        this.$message.error(res.result || '修改关爱级别失败')
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.labelList = []
      this.type = ''
      this.studentInfo = {}
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
.tag-item {
  margin-bottom: 16px;
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
}
.title-item {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}
</style>
